/* Constants */
import {
  GA_EVENT_CATEGORIES,
  GA_EVENT_ACTIONS,
  GA_EVENT_LABELS,
} from '../modules/analytics/googleAnalytics/googleAnalyticsConstants';

import {
  DAVINCI_EVENT_NAMES,
  DAVINCI_PAGE_TYPES,
} from '../modules/analytics/davinci/davinciConstants';

class DataSet {
  static createDataForDavinci(item, index, name, pageType) {
    return JSON.stringify({
      events: {
        click: ['davinci', 'wt'],
        view: ['davinci', 'wt'],
      },
      data: {
        eventNameForClick: DAVINCI_EVENT_NAMES.BANNER_CLICK,
        eventNameForView: DAVINCI_EVENT_NAMES.BANNER_VIEW,
        id: item.id,
        name: item.name,
        page_type: pageType ? pageType : null,
        mediaPath: item.mediaPath,
        position: index + 1 ? index + 1 : '1',
        sortId: index + 1 ? index + 1 : '1',
        placement: name,
        channel: 'pwa',
      },
      type: 'bannerDetails',
    });
  }

  static createFeedbackViewDataForDavinci(pageType, pageValue) {
    return JSON.stringify({
      events: {
        view: ['davinci'],
      },
      data: {
        eventName: 'FeedbackView',
        page_type: pageType,
        page_value: pageValue,
      },
      type: 'feedbackView',
    });
  }

  static createBannerViewDataForDavinci({
    pageType,
    pageValue,
    id,
    placement,
    bucket_name,
    bucket_position,
    position,
  }) {
    return JSON.stringify({
      events: {
        view: ['davinci']
      },
      data: {
        eventNameForView: DAVINCI_EVENT_NAMES.BANNER_VIEW,
        page_type: pageType,
        page_value: pageValue,
        id: id,
        placement: placement,
        bucket_name: bucket_name,
        bucket_position: bucket_position,
        position: position
      },
      type: 'bannerDetails',
    });
  }

  static createFilterWidgetViewDataForDavinci(pageType, pageValue, widgetFilters) {
    return JSON.stringify({
      events: {
        view: ['davinci'],
      },
      data: {
        eventName: 'FilterWidgetView',
        page_type: pageType,
        page_value: pageValue,
        widget_filters: widgetFilters,
      },
      type: 'filterWidgetView',
    });
  }

  static createSearchBoxClickData({
    page = '',
    isEnter,
  }) {
    let hbusData = {
      data: {
        eventName: 'SearchBoxClick',
        category: isEnter ? GA_EVENT_CATEGORIES.SEARCH : GA_EVENT_CATEGORIES.HEADER,
        label: isEnter ? GA_EVENT_LABELS.SEARCH_FOR : GA_EVENT_LABELS.SEARCH_BOX,
        event: GA_EVENT_ACTIONS.CLICK,
        channel: 'pwa',
        page: page,
        withCustomEventName: true,
      },
      type: 'searchBox',
    };

    if (isEnter) {
      hbusData.events = {enter: ['davinci', 'ga_new']};
    } else {
      hbusData.events = {click: ['davinci', 'ga_new']};
    }

    return JSON.stringify(hbusData);
  }

  static createCampaignBoxDataForDavinci(listTitle, campaign, index, pageType, pageValue) {
    return JSON.stringify({
      events: {
        click: ['davinci'],
        view: ['davinci'],
      },
      data: {
        eventNameForClick: DAVINCI_EVENT_NAMES.BANNER_CLICK,
        eventNameForView: DAVINCI_EVENT_NAMES.BANNER_VIEW,
        page_type: pageType,
        page_value: pageValue,
        position: index + 1 || '1',
        placement: listTitle || '',
        bucket_name: campaign?.campaignTextFromDb || campaign?.description,
      },
      type: 'bannerDetails',
    });
  }

  static createCampaignFilterComponentViewDataForDavinci(pageType, pageValue, widgetFilters) {
    return JSON.stringify({
      events: {
        view: ['davinci'],
      },
      data: {
        eventName: 'FilterWidgetView',
        page_type: pageType,
        page_value: pageValue,
        component: widgetFilters,
      },
      type: 'componentView',
    });
  }

  static createImageViewDataForDavinci({
    pageType,
    pageValue,
    categoryName,
    categoryId,
    merchantName,
    merchantId,
    productId,
    sku,
    position,
    location
  }) {
    return JSON.stringify({
      events: {
        click: ['davinci'],
        view: ['davinci'],
      },
      data: {
        eventName: 'ImageView',
        page_type: pageType,
        page_value: pageValue,
        category_name: categoryName,
        category_id: categoryId,
        merchant_name: merchantName,
        merchant_id: merchantId,
        product_id: productId,
        sku: sku,
        position,
        location: location === 'modal' && 'full' || location,
      },
      type: 'imageView',
    });
  }

  static createComponentViewDataForDavinci(
    {
      pageType,
      pageValue,
      placement,
      component,
      componentDetail,
      categoryHierarchy,
      ABTest,
      displayTextType,
      productId,
      merchantName,
      merchantId,
      listingId,
      position,
      price,
      componentOrder,
      componentType,
      url,
      paymentOptions,
      priceRange,
      otherSeller,
      popularSearches,
      contentGroupId,
      contentId
    }) {
    return JSON.stringify({
      events: {
        view: ['davinci'],
      },
      data: {
        eventName: 'ComponentView',
        placement: placement || '',
        component: component || '',
        component_detail: componentDetail || '',
        category_hierarchy: categoryHierarchy || '',
        page_type: pageType,
        page_value: pageValue,
        position: position || '',
        product_id: productId || '',
        merchant_name: merchantName || '',
        merchant_id: merchantId || '',
        listing_id: listingId || '',
        price: price || '',
        componentType: componentType || '',
        component_order: componentOrder || '',
        url: url || '',
        payment_options: paymentOptions || [],
        price_range: priceRange || '',
        other_seller: otherSeller || [],
        ABTest: ABTest || '',
        displayTextType: displayTextType || '',
        popularSearches: popularSearches || [],
        contentGroupId: contentGroupId || '',
        contentId: contentId || ''
      },
      type: 'componentView',
    });
  }

  static createVideoComponentViewDataForDavinci(
    {
      pageType,
      pageValue,
      position,
      location,
      categoryId,
      sku,
      categoryName,
      productId,
      merchantName,
      merchantId,
      title,
      totalCount,
      description,
      videoId,
      component_id,
      tagName,
      imageLabel,
    }) {
    return JSON.stringify({
      events: {
        view: ['davinci'],
      },
      data: {
        eventName: 'VideoComponentView',
        product_id: productId || '',
        merchant_name: merchantName || '',
        position: position || '',
        category_id: categoryId || '',
        page_value: pageValue,
        merchant_id: merchantId || '',
        sku: sku || '',
        category_name: categoryName || '',
        page_type: pageType,
        location: location || '',
        title: title || '',
        total_count: totalCount || '',
        description: description || '',
        videoId: videoId || '',
        component_id: component_id || '',
        tag_name: tagName || '',
        image_label: imageLabel || '',
      },
      type: 'videoComponentView',
    });
  }

  static createCampaignsViewDataForDavinci({sku, merchantName, merchantId, listingId, price, campaigns, productId}) {
    return JSON.stringify({
      events: {
        view: ['davinci'],
      },
      data: {
        eventName: DAVINCI_EVENT_NAMES.COMPONENT_VIEW,
        placement: DAVINCI_PAGE_TYPES.CAMPAIGN,
        component: DAVINCI_PAGE_TYPES.CAMPAIGN,
        component_detail: 'Kampanyalar',
        campaigns: campaigns.map((item, index) => {
          return {
            text: item?.campaignName || '',
            id: item?.campaignId?.toString() || '',
            url: '',
            position: index
          }
        }),
        page_type: 'product detail',
        page_value: sku,
        product_id: productId,
        merchant_name: merchantName,
        merchant_id: merchantId,
        listing_id: listingId || '',
        price: price?.toString() || ''
      },
      type: 'componentView',
    });
  }

  static createCampaignCardViewDataForDavinci(
    {
      pageType,
      pageValue,
      contentId,
      componentType,
      campaignType,
      productId,
      sku,
      position,
      reasonValue
    }) {
    return JSON.stringify({
      events: {
        view: ['davinci'],
      },
      data: {
        eventName: 'CampaignCardView',
        page_type: pageType,
        page_value: pageValue,
        contentId,
        componentType,
        campaignType,
        productId,
        sku,
        position,
        reasonValue
      },
      type: 'campaignCardView',
    });
  }
}

export default DataSet;
